import React,{useState,useEffect} from 'react'
import { withRouter } from 'react-router';
import headerBG from "../../resources/BG.png";
import {  female, male, maleAppView, femaleAppView } from "../../utils/tecahersCard/index";
import { Grid, Modal} from 'semantic-ui-react'
import "./tutorPage.css"

const TutorPage = (props) => {

    const [ teacherModal , setTeacherModal ] = useState(false);

    const handleCardClick = () => {
        setTeacherModal(true)
      }

      const handleModalShareNow = () => {



        document.getElementById("teacher-modal-1").style.display = "none"
        document.getElementById("teacher-modal-2").style.display = "flex"
      }

    return (
        <div className="welcome-page">

        <div id="header">
          <img id="headerBG" src={headerBG} />
        </div>
  
        <div id="welcomePage-detail">
          <div id="welcomePage-header">
            <div id="welcomePage-wishTeacher">
              <p id="reliveYourClassroom">
              Make your students miss your class
  
  
              </p>
              <p id="missingYourClassroom">
              Share this link with your students and let them recreate memories from your class
              </p>
              
            </div>
  
  
          </div>
  
          <div id="student-teachersCard">
            <p id="bringBack-memories"style={{borderBottom: "1px solid #E5E5E5", paddingBottom: "10px", marginBottom: "10px"}}>Your students can choose instances from below and recreate them with yous</p>
              {/* <p id="choose-card" >Choose kare ek memory aur batayein kaun hai apka #ClassWalaDosti ka saathi.</p> */}
              <Grid columns={2} >
                <div className="welcomepage-categoryLabel" >Sir wali class ki #ClassWaliDosti</div>
                <Grid.Row >
                  {maleAppView.map((image,index) => {
                    return (
                      <Grid.Column style={{marginTop:"1%",padding:"3%"}}>
                        <img index={index} src={image.firstImg} className="cards-image"  onClick={(e)=>handleCardClick(index, "male", image.class)} />
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
                <div className="welcomepage-categoryLabel">Ma'am wali class ki #ClassWaliDosti</div>
                <Grid.Row >
                  {femaleAppView.map((image,index) => {
                    return (
                      <Grid.Column style={{marginTop:"1%",padding:"3%"}}>
                        <img index={index} src={image.firstImg} className="cards-image"  onClick={(e)=>handleCardClick(index, "female", image.class)} />
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
  
              </Grid>
              <div id="tutor-bottom-block">
              <button id="tutor-bottom-btn"
              onClick={()=>handleCardClick()} 
              >Allow Sharing With Students</button>
              </div>

                  <Modal
                  open={teacherModal}
                  >
                    <div id="teacher-modal-1" >
                    <div id="teacher-modal-head">Allow Sharing</div>
                    <div id="teacher-modal-content">By click on share you are allowing Classplus to promote this event amongst all your students</div>
                    <button id="teacher-modal-button" onClick={()=>{
                      handleModalShareNow()
                    }} >Share Now</button>
                    </div>

                    <div id="teacher-modal-2" >
                    <div id="teacher-modal-head">Thanks!</div>
                    <div id="teacher-modal-content">BYour request has been registered.</div>
                    <button id="teacher-modal-button" onClick={()=>setTeacherModal(false)} >Done</button>
                    </div>
                  </Modal>


              
            </div>
        </div>
      </div>
    )
}

export default TutorPage
